/**
 * This is the source code of https://github.com/colorjs/color-namer converted to TypeScript and 
 * improved a bit. Most of the work done for that package was assembling the color lists. This is
 * the entirety of the code (the complicated parts are done by chromajs as well).
 */
import chroma from "chroma-js";
import basic from './basic';
import html from './html';
import ntc from './ntc';
import pantone from './pantone';
import roygbiv from './roygbiv';
import x11 from './x11';

type ColorItem = { name: string, hex: string };
type ColorResultItem = ColorItem & { distance: number };
type ListName = 'basic' | 'html' | 'ntc' | 'pantone' | 'roygbiv' | 'x11';
type List = ColorItem[];
type ResultList = ColorResultItem[];
interface ColorNamerOpts {
    pick?: ListName[],
    omit?: ListName[],
    distance?: 'deltaE'
}

let lists : { [Name in ListName]: List } = { basic, html, ntc, pantone, roygbiv, x11 };
let cache = new WeakMap<{ color: string, options: ColorNamerOpts }>();

const nameColor = (color: string, options: ColorNamerOpts) : ResultList => {
    options = options || {}

    let cacheKey = { color, options };
    if (cache.has(cacheKey)) {
        return cache.get(cacheKey)
    }

    let deltaE = String(options.distance).toLowerCase() === 'deltae';
    let chromaColor = chroma(color);
    let results : ColorResultItem[] = [];
    for (let key in lists) {
        if (options.pick && options.pick.indexOf(<ListName> key) === -1) {
            continue
        }

        if (options.omit && options.omit.indexOf(<ListName> key) !== -1) {
            continue
        }

        let list = lists[<ListName> key];
        let resultItems : ResultList = list.map(item => {
            return { 
                ...item, 
                distance: deltaE ? chroma.deltaE(chromaColor, chroma(item.hex)) : chroma.distance(chromaColor, chroma(item.hex))
            }
        }).filter(item => item.distance <= 10).sort((a, b) => a.distance - b.distance);

        results = [...results, ...resultItems];
    }

    cache.set(cacheKey, results);
    return results
}

export {
    nameColor
}